import { Fragment } from 'preact'
import { useMemo } from 'preact/hooks'

import type {
  CookieCategory,
  CookieRecord,
} from '../../../../services/cookieTranslationService/types'

import { getCookieDomainFromWebsiteUrl } from '#src/assets/core/consentConfig.ts'
import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { CookieControllerList } from '#src/assets/ui/overview/components/CookieControllerList.tsx'
import { Heading } from '#src/assets/ui/shared/components/Heading.tsx'
import { Paragraph } from '#src/assets/ui/shared/components/Paragraph.tsx'
import type { SiteConfig } from '#src/models/site-configs/siteConfigs.ts'

export function PolicySectionTypes({
  t,
  siteConfig,
  cookiesByCategory,
}: {
  t: CookieConsentTranslator
  siteConfig: SiteConfig
  cookiesByCategory: Record<CookieCategory, Array<CookieRecord>>
}) {
  const cookieDomainFromWebsite = getCookieDomainFromWebsiteUrl(
    siteConfig.domain,
  )

  const cookiesList = useMemo(
    () =>
      Object.entries(cookiesByCategory) as Array<
        [CookieCategory, Array<CookieRecord>]
      >,
    [cookiesByCategory],
  )

  return (
    <Fragment>
      <Heading level={3}>{t('policyTypesTitle')}</Heading>
      {cookiesList.map(([category, cookies]) => {
        if (cookies.length === 0) {
          return null
        }

        return (
          <div key={category}>
            <Heading level={4}>{t(`policySectionTitle.${category}`)}</Heading>
            <Paragraph>{t(`policySectionDescription.${category}`)}</Paragraph>
            <CookieControllerList
              cookies={cookies}
              fallbackDomain={cookieDomainFromWebsite}
              t={t}
            />
          </div>
        )
      })}
    </Fragment>
  )
}
